
import React from "react";
import FAQItem from "./FAQItem";

const TokensSection: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">Tokens and Costs</h2>
      
      <FAQItem question="What are tokens and how do they work?">
        <p className="text-foreground mb-3">
          Tokens are our usage currency. Each remote viewing session (target generation, analysis, and feedback) consumes tokens based on:
        </p>
        <ul className="list-disc list-inside text-foreground space-y-1 ml-4">
          <li>AI processing required for personalized feedback</li>
          <li>Target generation and validation</li>
          <li>Image analysis and comparison algorithms</li>
        </ul>
      </FAQItem>

      <FAQItem question="How many tokens do I start with?">
        <p className="text-foreground">
          New users receive 100,000 tokens free upon registration - enough for multiple complete remote viewing sessions to explore the platform.
        </p>
      </FAQItem>

      <FAQItem question="What happens when I run out of tokens?">
        <p className="text-foreground">
          You can purchase additional token packages through our secure payment system. Token packages are designed to be affordable and provide extensive practice opportunities.
        </p>
      </FAQItem>

      <FAQItem question="Can I track my token usage?">
        <p className="text-foreground">
          Yes, your current token balance is always visible in the interface, and you can view detailed usage history in your account settings.
        </p>
      </FAQItem>
    </section>
  );
};

export default TokensSection;
